import { SchedulerPro, type SchedulerProConfig } from '@bryntum/schedulerpro'

import { type MoveOrdersPayload } from '@/components/modals/MoveOrdersModal'
import { type ControlledNavigateFunction } from '@/routing'

import { createSchedulerConfig } from './createSchedulerConfig'

export function createScheduler(
  appendTo: string,
  navigate: ControlledNavigateFunction<uui.routing.Routing | uui.routing.Setup>,
  showMoveOrdersModal: (payload: MoveOrdersPayload) => void,
  onHeaderMenuBeforeShow: SchedulerProConfig['onHeaderMenuBeforeShow'],
) {
  const scheduler = new SchedulerPro(
    createSchedulerConfig(appendTo, navigate, showMoveOrdersModal, onHeaderMenuBeforeShow),
  )
  return scheduler
}
